/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * API Reference
 * OpenAPI spec version: 1.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  QueryFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  GetBanks200,
  GetBanksParams
} from './schema'



/**
 * @summary Get bank data by Swift code
 */
export const getBanks = (
    params: GetBanksParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetBanks200>> => {
    return axios.get(
      `/banks`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetBanksQueryKey = (params: GetBanksParams,) => [`/banks`, ...(params ? [params]: [])];

    
export type GetBanksQueryResult = NonNullable<Awaited<ReturnType<typeof getBanks>>>
export type GetBanksQueryError = AxiosError<unknown>

export const useGetBanks = <TData = Awaited<ReturnType<typeof getBanks>>, TError = AxiosError<unknown>>(
 params: GetBanksParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getBanks>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBanksQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBanks>>> = ({ signal }) => getBanks(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getBanks>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

